import { observer } from 'mobx-react';
import ParticipantStore from '../../../../../../ParticipantStore';
import { AddLicenseToParticipantsStore } from '../Store';
import { InitialReady, FetchingLicenseOptions, LicensesReady } from '.././Types';
import Form from './Form';
import { T } from '../../../../../../Translations';
import ParticipantInfo from '../../../Table/LicenseAllocations/ModalForm/ParticipantInfo';

interface Props {
  state: InitialReady | FetchingLicenseOptions | LicensesReady;
  checkedParticipants: ParticipantStore[];
  submitting: () => void;
  store: AddLicenseToParticipantsStore;
}

function ReadyView({ state, submitting, checkedParticipants, store }: Props) {
  return (
    <>
      <div className="pt-8 font-semibold">
        <T kind="Selected participant(s)" />
      </div>
      {checkedParticipants.map((participantStore) => (
        <ParticipantInfo
          key={participantStore.resource.payload.id}
          participantStore={participantStore}
        />
      ))}
      <Form state={state} submitting={submitting} store={store} />
    </>
  );
}

export default observer(ReadyView);
